import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import { AppState } from "../../../../app.state";
import { select, Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { LoadingService } from "../../../../loading/loading.service";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { selectUsuario } from "../../../../states/usuario/selector";
import { cancelarEntregableDespacho } from "../../../../states/despacho/actions";
import { ICancelarEntregable } from "../../../../interfaces/despacho";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-cancelar-entregable",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
  ],
  templateUrl: "./cancelar-entregable.component.html",
  styleUrl: "./cancelar-entregable.component.css",
})
export class CancelarEntregableComponent {
  @Input() tema!: any;
  @Output() cancelAction: EventEmitter<void> = new EventEmitter<void>();
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  motivoJustificacion = new FormControl("", [Validators.required]);
  public catJustificacion: any[] = [];

  entregables: any = [];
  selectAllChecked = false;
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<CancelarEntregableComponent>,
    public despachoService: DespachoService,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  async ngOnInit() {
    this.loadingService.show();

    this.despachoService.getJustipfiicacion("").subscribe((data) => {
      this.loadingService.hide();
      this.catJustificacion = data;
    });

    const resEntregables = await firstValueFrom(
      this.despachoService.listarEntregables(this.data.id_tema)
    );
    if (!resEntregables.error) {
      this.entregables = resEntregables.entregables.map((entregable: any) => {
        return { ...entregable, selected: false };
      });
    }
    
    this.loadingService.hide();
  }

  selectAll(checked: boolean): void {
    this.entregables.forEach((entregable: any) => {
      entregable.selected = checked;
    });
    this.selectAllChecked = checked;
  }

  updateSelectAllState(): void {
    const allSelected = this.entregables.every(
      (entregable: any) => entregable.selected
    );
    this.selectAllChecked = allSelected;
  }

  getEntregaablesChecked(): any {
    return this.entregables.filter((entregable: any) => entregable.selected);
  }
  async save() {
    this.dialogRef.close();
    this.loadingService.show();
    const user = structuredClone(this.stateUser.state().usuario);

    const entregable: ICancelarEntregable = {
      id_tema: this.data.id_tema,
      id_usuario: user.uid,
      justificacion: this.motivoJustificacion?.value ?? "",
      usuario: user.nombre,
      entregables: [...this.getEntregaablesChecked()],
    };
    console.log("payload", entregable);

    try {
      const cancelarEntregable = await this.despachoService.cancelarEntregables(
        entregable
      );
      if (!cancelarEntregable.error) {
        this.store.dispatch(cancelarEntregableDespacho({ entregable }));
      }
    } catch (error) {
      this.loadingService.hide();
    }
  }

  cancel(): void {
    this.cancelAction.emit();
  }
}
